module.exports = __webpack_public_path__ + "static/media/multi-sample-bg.37d3b3ea.png";